// extracted by mini-css-extract-plugin
export default {"pill":"_1fGnsAvYkOQTpmqKcrWc5k","name":"_3WawP9ogQn8slQOzPWj2Wq"};